import { render, staticRenderFns } from "./AxGroupListPanel2.vue?vue&type=template&id=2bd0e26a&scoped=true"
import script from "./AxGroupListPanel2.vue?vue&type=script&lang=ts"
export * from "./AxGroupListPanel2.vue?vue&type=script&lang=ts"
import style0 from "./AxGroupListPanel2.vue?vue&type=style&index=0&id=2bd0e26a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd0e26a",
  null
  
)

export default component.exports